<template>
  <button
    type="button"
    role="switch"
    :aria-checked="locked || modelValue"
    :disabled="disabled"
    @click="!locked && emit('update:modelValue', !modelValue)"
    :class="[
      'relative inline-flex shrink-0 rounded-full transition-colors duration-200',
      'w-16 h-[30px]',
      locked || modelValue ? activeClass : 'bg-accent/50',
      locked ? 'cursor-default' : disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer',
    ]"
  >
    <span
      :class="[
        'absolute inset-y-0 flex items-center text-[12px] font-semibold select-none transition-all duration-200',
        locked || modelValue ? 'right-[10px] text-primary-text' : 'left-[10px] text-accent-text',
      ]"
    >
      {{ locked || modelValue ? $t('toggle.yes') : $t('toggle.no') }}
    </span>

    <span
      :class="[
        'absolute top-[3px] h-6 w-6 rounded-full bg-white shadow transition-transform duration-200',
        locked || modelValue ? 'translate-x-[5px]' : 'translate-x-[35px]',
      ]"
    />
  </button>
</template>

<script setup lang="ts">
  withDefaults(
    defineProps<{
      modelValue: boolean;
      disabled?: boolean;
      locked?: boolean;
      activeClass?: string;
    }>(),
    {
      disabled: false,
      locked: false,
      activeClass: 'bg-primary',
    }
  );

  const emit = defineEmits<{
    'update:modelValue': [value: boolean];
  }>();
</script>
